/**
 *      Import
 *      - Libraries
 */
import * as React from 'react'

/**
 *      Import
 *      - Components
 */
import NotificationItem from './NotificationItem'

/**
 * Class for the content in the Notification box
 *
 * @export
 * @class NotificationsContent
 * @extends {React.Component<any, any>}
 */
export default class NotificationsContent extends React.Component<any, any> {
    render() {
        return (
            <div>
                {(this.props.notificationList && this.props.notificationList.length !== 0) ?
                    this.props.notificationList.slice(0).reverse().map((item, index) => {
                        return (
                            item.days <= 31 && <NotificationItem
                                key={index}
                                type={item.type}
                                title={item.title}
                                summaryId={item.summaryId}
                                time={item.days}
                                state={item.state}
                                id={item.id}
                            >
                                {item.text}
                            </NotificationItem>
                        )
                    })
                    :
                    <div className="notifications__box__item">
                        <div className="notifications__box__item__content empty">
                            You don't have notifications!
                        </div>
                    </div>
                }

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/Notifications/components/NotificationsContent.tsx